import React from "react";
import corporateLogo from "../../../../assets/corporate_logo.svg";
import { SearchBox, SearchBoxProps } from "../search-box/search-box";
import "./header.scss";

export type HeaderProps = {
  title: string;
  subtitle?: string;
} & SearchBoxProps;

export const HelpHeader: React.FC<HeaderProps> = ({
  title,
  subtitle,
  query,
  condition,
  onChangeSearchText,
  onChangeSearchCondition,
}) => {
  return (
    <div className="help-top-header">
      <div className="help-search-contents">
        <h1 className="help-top-title">
          <img
            src={corporateLogo}
            alt="株式会社グラファー 会社ロゴ"
            style={{
              width: "194px",
            }}
          />
          {title}
          <span className="help-top-subtitle">{subtitle}</span>
        </h1>
        <div className="help-search-box">
          <p className="help-sub-text">どんなことでお困りですか？</p>
          <div className="help-search-content">
            <p>調べたい言葉を入力してください。例：パスワードリセット</p>
            <SearchBox
              {...{
                query,
                condition,
                onChangeSearchText,
                onChangeSearchCondition,
              }}
            />
          </div>
        </div>
      </div>
    </div>
  );
};
